import {Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef} from '@angular/core';
import {notify, Sensor, SensorHistoryLoader} from 'shared';
import {SensorHistoryRequest} from '../sensor-history-request';
import {SensorService} from '../../stores/sensor.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-sensor-history-popup',
  templateUrl: './sensor-history-popup.component.html',
  styleUrls: ['./sensor-history-popup.component.scss']
})
export class SensorHistoryPopupComponent implements OnInit, OnDestroy {

  @ContentChild(TemplateRef)
  templateRef: TemplateRef<any>;

  @Input()
  sensor: Sensor;

  request = new SensorHistoryRequest();

  @Input()
  title: string;

  @Input()
  visible: boolean;

  @Output()
  visibleChange = new EventEmitter<boolean>();
  private requestSub: Subscription;

  loader = new SensorHistoryLoader();
  private detectChanges: boolean;

  constructor(private sensorService: SensorService) {
    this.close = this.close.bind(this);
  }

  ngOnInit(): void {
    this.requestSub = this.request.submit$.subscribe(() => {
      this.request.isLoading = true;
      this.sensorService.history(this.loader, this.sensor.id, this.request.from, this.request.to, this.detectChanges).subscribe((l) => {
        if (l.isLoaded) {
          if (l.isEmpty()) {
            notify('Pas données dans l\'intervale sélectioné');
            this.request.isLoading = false;
            return;
          }
          this.sensor = l.sensor;
          this.request.isLoading = false;
        }
      });
    });
  }

  closed(e: any) {
    this.visibleChange.emit(false);
  }

  async onShowing(e: any) {
  }

  onShown(e: any) {
    // Fetch today by default;
    this.request.reset();
    this.request.submit();
  }

  close() {
    this.visible = false;
  }

  showHistory(sensor: Sensor, detectChanges = false) {
    this.sensor = sensor;

    this.detectChanges = detectChanges;
    this.visible = true;
  }

  ngOnDestroy(): void {
    this.requestSub.unsubscribe();
  }
}
